import { DigiAIXCoreAppState } from './app-state';

export const selectRouterState = (state: DigiAIXCoreAppState) => state.router;
